<template>
  <v-row class="ma-0">
    <v-col cols="8">
      <h3>{{ $t('Configuração de indicadores') }}</h3>
      <span>
        {{
          $t(
            'Configure cada indicador escolhido e adicione sua análise crítica'
          )
        }}
      </span>
    </v-col>
    <v-col cols="4" class="d-flex justify-end">
      <v-btn
        class="primary-button ma-0"
        depressed
        v-if="isEditing"
        @click="refreshData"
      >
        Atualizar dados
      </v-btn>
    </v-col>

    <v-col cols="12">
      <v-divider></v-divider>
    </v-col>

    <v-col
      cols="12"
      v-if="selection.filter((x) => x.includes('1.')).length > 0"
    >
      <v-expansion-panels flat hover style="border-radius: 8px">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <strong>{{ $t('Quantitativos') }}</strong>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-expansion-panels flat hover style="border-radius: 8px">
              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('1.1 - Equipamentos por setor')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">1.1</h3>
                    {{ $t('Equipamentos por setor') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <EquipmentBySectorChart
                    :filterProp="
                      isEditing
                        ? chartInfos.find(
                            (x) => x.chart == '1.1 - Equipamentos por setor'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '1.1 - Equipamentos por setor'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '1.1 - Equipamentos por setor'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="
                  selection.includes(
                    '1.2 - Equipamentos Desativados no Período'
                  )
                "
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">1.2</h3>
                    {{ $t('Equipamentos Desativados no Período') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <AlienatedEquip
                    :filterProp="
                      isEditing
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.2 - Equipamentos Desativados no Período'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart == '1.2 - Equipamentos Desativados no Período'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.2 - Equipamentos Desativados no Período'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('1.3 - Solicitações por setor')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">1.3</h3>
                    {{ $t('Solicitações por setor') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <RequestBySector
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '1.3 - Solicitações por setor'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '1.3 - Solicitações por setor'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '1.3 - Solicitações por setor'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '1.3 - Solicitações por setor'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="
                  selection.includes(
                    '1.4 - Equipamentos Parados x Tipo de Pendencia'
                  )
                "
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">1.4</h3>
                    {{ $t('Equipamentos Parados x Tipo de Pendencia') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <StoppedEquipPendingType
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '1.4 - Equipamentos Parados x Tipo de Pendencia'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.4 - Equipamentos Parados x Tipo de Pendencia'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '1.4 - Equipamentos Parados x Tipo de Pendencia'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.4 - Equipamentos Parados x Tipo de Pendencia'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="
                  selection.includes('1.5 - Top 5 equipamentos com mais falhas')
                "
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">1.5</h3>
                    {{ $t('Top 5 equipamentos com mais falhas') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <TopFiveEquipFailures
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart == '1.5 - Top 5 equipamentos com mais falhas'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.5 - Top 5 equipamentos com mais falhas'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart == '1.5 - Top 5 equipamentos com mais falhas'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.5 - Top 5 equipamentos com mais falhas'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('1.6 - Prevalência solução defeito')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">1.6</h3>
                    {{ $t('Prevalência solução defeito') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <DefectSolutionPrev
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '1.6 - Prevalência solução defeito'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart == '1.6 - Prevalência solução defeito'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '1.6 - Prevalência solução defeito'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart == '1.6 - Prevalência solução defeito'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="
                  selection.includes(
                    '1.7 - Serviços solicitados x concluídos - Período'
                  )
                "
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">1.7</h3>
                    {{ $t('Serviços solicitados x concluídos - Período') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <SolicitedVConcluded
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '1.7 - Serviços solicitados x concluídos - Período'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.7 - Serviços solicitados x concluídos - Período'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '1.7 - Serviços solicitados x concluídos - Período'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.7 - Serviços solicitados x concluídos - Período'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="
                  selection.includes(
                    '1.8 - Corretivas solicitadas x executadas - Acumulado'
                  )
                "
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">1.8</h3>
                    {{ $t('Corretivas solicitadas x executadas - Acumulado') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <CorrectiveScheXExec
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '1.8 - Corretivas solicitadas x executadas - Acumulado'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.8 - Corretivas solicitadas x executadas - Acumulado'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '1.8 - Corretivas solicitadas x executadas - Acumulado'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.8 - Corretivas solicitadas x executadas - Acumulado'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('1.9 - Resolutividade interna')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">1.9</h3>
                    {{ $t('Resolutividade Interna') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <InternalResolvability
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '1.9 - Resolutividade interna'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '1.9 - Resolutividade interna'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '1.9 - Resolutividade interna'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '1.9 - Resolutividade interna'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('1.10 - Preventiva x Corretiva')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">1.10</h3>
                    {{ $t('Preventiva x Corretiva') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <PreventiveXCorrective
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '1.10 - Preventiva x Corretiva'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '1.10 - Preventiva x Corretiva'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '1.10 - Preventiva x Corretiva'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '1.10 - Preventiva x Corretiva'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="
                  selection.includes(
                    '1.11 - Preventivas agendadas x executadas - Acumulado'
                  )
                "
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">1.11</h3>
                    {{ $t('Preventivas Agendadas x Executas - Acumulado') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <PreventiveSchedXExec
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '1.11 - Preventivas agendadas x executadas - Acumulado'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.11 - Preventivas agendadas x executadas - Acumulado'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '1.11 - Preventivas agendadas x executadas - Acumulado'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.11 - Preventivas agendadas x executadas - Acumulado'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="
                  selection.includes(
                    '1.12 - Calibrações agendadas x executadas'
                  )
                "
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">1.12</h3>
                    {{ $t('Calibrações agendadas x executadas - Acumulado') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <CalibSchedXExec
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart == '1.12 - Calibrações agendadas x executadas'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.12 - Calibrações agendadas x executadas'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart == '1.12 - Calibrações agendadas x executadas'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.12 - Calibrações agendadas x executadas'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="
                  selection.includes(
                    '1.13 - Segurança elétrica agendada x executada - acumulado'
                  )
                "
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">1.13</h3>
                    {{
                      $t('Segurança Elétrica agendada x executada - Acumulado')
                    }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <EletricSecSchedXExec
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '1.13 - Segurança elétrica agendada x executada - acumulado'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.13 - Segurança elétrica agendada x executada - acumulado'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '1.13 - Segurança elétrica agendada x executada - acumulado'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.13 - Segurança elétrica agendada x executada - acumulado'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="
                  selection.includes(
                    '1.14 - Histórico de migração de equipamentos'
                  )
                "
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">1.14</h3>
                    {{ $t('Histórico de migração de equipamentos') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <HistoricalMigration
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '1.14 - Histórico de migração de equipamentos'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.14 - Histórico de migração de equipamentos'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '1.14 - Histórico de migração de equipamentos'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '1.14 - Histórico de migração de equipamentos'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="
                  institution.departmentTypes.includes(1) &&
                  selection.includes('1.15 - Solicitações por Oficina')
                "
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">1.15</h3>
                    {{ $t('Solicitações por Oficina') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <OrderByWorkshop
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '1.15 - Solicitações por Oficina'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '1.15 - Solicitações por Oficina'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '1.15 - Solicitações por Oficina'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '1.15 - Solicitações por Oficina'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>

    <v-col
      cols="12"
      v-if="selection.filter((x) => x.includes('1.')).length > 0"
    >
      <v-divider></v-divider>
    </v-col>

    <v-col
      cols="12"
      v-if="selection.filter((x) => x.includes('2.')).length > 0"
    >
      <v-expansion-panels flat hover style="border-radius: 8px">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <strong>{{ $t('Tempos') }}</strong>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-expansion-panels flat hover style="border-radius: 8px">
              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('2.1 - Tempo de máquina parada')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">2.1</h3>
                    {{ $t('Tempo de máquina parada') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <StoppedMachine
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '2.1 - Tempo de máquina parada'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '2.1 - Tempo de máquina parada'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '2.1 - Tempo de máquina parada'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '2.1 - Tempo de máquina parada'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                    :standardEquipments="standardEquipments"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="
                  selection.includes(
                    '2.2 - Tempo médio entre falhas por equipamento padrão'
                  )
                "
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">2.2</h3>
                    {{ $t('Tempo médio entre falhas por equipamento padrão') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <StandEquipFailures
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '2.2 - Tempo médio entre falhas por equipamento padrão'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '2.2 - Tempo médio entre falhas por equipamento padrão'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '2.2 - Tempo médio entre falhas por equipamento padrão'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '2.2 - Tempo médio entre falhas por equipamento padrão'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                    :standardEquipments="standardEquipments"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="
                  selection.includes(
                    '2.3 - Tempo médio entre falhas por equipamento'
                  )
                "
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">2.3</h3>
                    {{ $t('Tempo médio entre falhas por equipamento') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <TotalServiceTime
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '2.3 - Tempo médio entre falhas por equipamento'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '2.3 - Tempo médio entre falhas por equipamento'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '2.3 - Tempo médio entre falhas por equipamento'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '2.3 - Tempo médio entre falhas por equipamento'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                    :standardEquipments="standardEquipments"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="
                  selection.includes('2.4 - Atendimento x Previsão atendimento')
                "
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">2.4</h3>
                    {{ $t('Atendimento x Previsão atendimento') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ServiceForecast
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart == '2.4 - Atendimento x Previsão atendimento'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '2.4 - Atendimento x Previsão atendimento'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart == '2.4 - Atendimento x Previsão atendimento'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '2.4 - Atendimento x Previsão atendimento'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('2.5 - Chamados atendidos no prazo')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">2.5</h3>
                    {{ $t('Chamados Corretivos Atendidos no Prazo') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <CallsAnsweredChart
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '2.5 - Chamados atendidos no prazo'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart == '2.5 - Chamados atendidos no prazo'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '2.5 - Chamados atendidos no prazo'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart == '2.5 - Chamados atendidos no prazo'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="
                  selection.includes('2.6 - Resolução x Previsão resolução')
                "
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">2.6</h3>
                    {{ $t('Resolução x Previsão resolução') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ResolutionForecast
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '2.6 - Resolução x Previsão resolução'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart == '2.6 - Resolução x Previsão resolução'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '2.6 - Resolução x Previsão resolução'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart == '2.6 - Resolução x Previsão resolução'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('2.7 - Chamados resolvidos no prazo')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">2.7</h3>
                    {{ $t('Chamados Corretivos Resolvidos no Prazo') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <CallsResolvedChart
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '2.7 - Chamados resolvidos no prazo'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart == '2.7 - Chamados resolvidos no prazo'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '2.7 - Chamados resolvidos no prazo'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart == '2.7 - Chamados resolvidos no prazo'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="
                  selection.includes(
                    '2.8 - Tempo de atendimento interno por setor'
                  )
                "
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">2.8</h3>
                    {{ $t('Tempo de Atendimento Interno por Setor') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ServiceTimeDepartment
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '2.8 - Tempo de atendimento interno por setor'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '2.8 - Tempo de atendimento interno por setor'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '2.8 - Tempo de atendimento interno por setor'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '2.8 - Tempo de atendimento interno por setor'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                    :standardEquipments="standardEquipments"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="
                  selection.includes(
                    '2.9 - Tempo de atendimento interno por criticidade'
                  )
                "
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">2.9</h3>
                    {{ $t('Tempo de atendimento interno por criticidade') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ServiceTimeCrit
                    :filterProp="
                      isEditing
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '2.9 - Tempo de atendimento interno por criticidade'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '2.9 - Tempo de atendimento interno por criticidade'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '2.9 - Tempo de atendimento interno por criticidade'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                    :standardEquipments="standardEquipments"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('2.10 - Tempo produtivo')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">2.10</h3>
                    {{ $t('Tempo Produtivo') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ProdTime
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '2.10 - Tempo produtivo'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '2.10 - Tempo produtivo'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '2.10 - Tempo produtivo'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '2.10 - Tempo produtivo'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                    :standardEquipments="standardEquipments"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('2.11 - Tempo produtivo por setor')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">2.11</h3>
                    {{ $t('Tempo produtivo por setor') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ProdTimeSector
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '2.11 - Tempo produtivo por setor'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '2.11 - Tempo produtivo por setor'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '2.11 - Tempo produtivo por setor'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '2.11 - Tempo produtivo por setor'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                    :standardEquipments="standardEquipments"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="
                  selection.includes(
                    '2.12 - Tempo médio de resolução interna por criticidade'
                  )
                "
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">2.12</h3>
                    {{ $t('Tempo médio de resolução interna por criticidade') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ResolutionTimeCrit
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '2.12 - Tempo médio de resolução interna por criticidade'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '2.12 - Tempo médio de resolução interna por criticidade'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) =>
                          x.chart ==
                          '2.12 - Tempo médio de resolução interna por criticidade'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart ==
                              '2.12 - Tempo médio de resolução interna por criticidade'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                    :standardEquipments="standardEquipments"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>

    <v-col
      cols="12"
      v-if="selection.filter((x) => x.includes('2.')).length > 0"
    >
      <v-divider></v-divider>
    </v-col>

    <v-col
      cols="12"
      v-if="selection.filter((x) => x.includes('3.')).length > 0"
    >
      <v-expansion-panels flat hover style="border-radius: 8px">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <strong>{{ $t('Custos de Manutenção') }}</strong>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-expansion-panels flat hover style="border-radius: 8px">
              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('3.1 - Custos por peça avulsa')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">3.1</h3>
                    {{ $t('Custos por Peça Avulsa') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <CostPerPiece
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '3.1 - Custos por peça avulsa'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '3.1 - Custos por peça avulsa'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '3.1 - Custos por peça avulsa'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '3.1 - Custos por peça avulsa'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('3.2 - Custos por serviço avulso')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">3.2</h3>
                    {{ $t('Custos por serviço avulso') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <CostPerService
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '3.2 - Custos por serviço avulso'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '3.2 - Custos por serviço avulso'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '3.2 - Custos por serviço avulso'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '3.2 - Custos por serviço avulso'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('3.3 - Custo por setor')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">3.3</h3>
                    Custos por setor
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <CostPerSector
                    :filterProp="
                      isEditing &&
                      chartInfos.find((x) => x.chart == '3.3 - Custo por setor')
                        ? chartInfos.find(
                            (x) => x.chart == '3.3 - Custo por setor'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find((x) => x.chart == '3.3 - Custo por setor')
                        ? chartInfos.find(
                            (x) => x.chart == '3.3 - Custo por setor'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('3.4 - Custo por ID equipamento')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">3.4</h3>
                    {{ $t('Custos por ID de equipamento') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <CostPerId
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '3.4 - Custo por ID equipamento'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '3.4 - Custo por ID equipamento'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '3.4 - Custo por ID equipamento'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '3.4 - Custo por ID equipamento'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('3.5 - Custo evitado')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">3.5</h3>
                    {{ $t('Custo evitado') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <AvoidedCosts
                    :filterProp="
                      isEditing &&
                      chartInfos.find((x) => x.chart == '3.5 - Custo evitado')
                        ? chartInfos.find(
                            (x) => x.chart == '3.5 - Custo evitado'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find((x) => x.chart == '3.5 - Custo evitado')
                        ? chartInfos.find(
                            (x) => x.chart == '3.5 - Custo evitado'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>

    <v-col
      cols="12"
      v-if="selection.filter((x) => x.includes('3.')).length > 0"
    >
      <v-divider></v-divider>
    </v-col>

    <v-col
      cols="12"
      v-if="selection.filter((x) => x.includes('4.')).length > 0"
    >
      <v-expansion-panels flat hover style="border-radius: 8px">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <strong>{{ $t('Controle de Qualidade') }}</strong>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-expansion-panels flat hover style="border-radius: 8px">
              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('4.1 - Notas das avaliações O.S.')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">4.1</h3>
                    {{ $t('Notas das avaliações de Chamados') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <OrderRatings
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '4.1 - Notas das avaliações O.S.'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '4.1 - Notas das avaliações O.S.'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '4.1 - Notas das avaliações O.S.'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '4.1 - Notas das avaliações O.S.'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('4.2 - Ranking fornecedor')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">4.2</h3>
                    {{ $t('Ranking fornecedor') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <RankingSupplier
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '4.2 - Ranking fornecedor'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '4.2 - Ranking fornecedor'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '4.2 - Ranking fornecedor'
                      )
                        ? chartInfos.find(
                            (x) => x.chart == '4.2 - Ranking fornecedor'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                class="my-2"
                v-if="selection.includes('4.3 - Adesão ao módulo de chamados')"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">4.3</h3>
                    {{ $t('Adesão ao módulo de chamados') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <AdhesionCalledMod
                    :filterProp="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '4.3 - Adesão ao módulo de chamados'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart == '4.3 - Adesão ao módulo de chamados'
                          )
                        : {}
                    "
                    :review="
                      isEditing &&
                      chartInfos.find(
                        (x) => x.chart == '4.3 - Adesão ao módulo de chamados'
                      )
                        ? chartInfos.find(
                            (x) =>
                              x.chart == '4.3 - Adesão ao módulo de chamados'
                          ).review
                        : ''
                    "
                    @setInfos="saveChartInfo"
                    :institution="institution"
                    :unidades="unidades"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>

    <v-col cols="12">
      <v-card-actions class="justify-space-between">
        <v-btn text @click="$emit('back')">
          <v-icon>mdi-chevron-left</v-icon>
          {{ $t('Voltar') }}
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn text @click="submit">
          {{ $t('Continuar') }}
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-col>
  </v-row>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'
import GeneralService from '../../../../../../services/GeneralService'

import EquipmentBySectorChart from './charts/quantitative/equipmentBySector.vue'
import RequestBySector from './charts/quantitative/requestBySector.vue'
import TopFiveEquipFailures from './charts/quantitative/topFiveEquipFailures.vue'
import DefectSolutionPrev from './charts/quantitative/defectSolutionPrev.vue'
import SolicitedVConcluded from './charts/quantitative/solicitedVConcluded.vue'
import CorrectiveScheXExec from './charts/quantitative/correctiveSchedXExec.vue'
import InternalResolvability from './charts/quantitative/internalResolvability.vue'
import PreventiveXCorrective from './charts/quantitative/preventiveXCorrective.vue'
import PreventiveSchedXExec from './charts/quantitative/preventiveSchedxExec.vue'
import CalibSchedXExec from './charts/quantitative/calibSchedXExec.vue'
import EletricSecSchedXExec from './charts/quantitative/eletricSecSchedXExec.vue'
import AlienatedEquip from './charts/quantitative/alienatedEquip.vue'
import HistoricalMigration from './charts/quantitative/historicalMigration.vue'
import StoppedEquipPendingType from './charts/quantitative/stoppedEquipPendingType.vue'
import OrderByWorkshop from './charts/quantitative/orderByWorkshop.vue'

import StoppedMachine from './charts/time/stoppedMachine.vue'
import StandEquipFailures from './charts/time/standEquipFailures.vue'
import TotalServiceTime from './charts/time/totalServiceTime.vue'
import ServiceTimeDepartment from './charts/time/serviceTimeDepartment.vue'
import ServiceTimeCrit from './charts/time/serviceTimeCrit.vue'
import ProdTimeSector from './charts/time/prodTimeSector.vue'
import ProdTime from './charts/time/prodTime.vue'
import ResolutionTimeCrit from './charts/time/resolutionTimeCrit.vue'

import CostPerPiece from './charts/costs/costPerPiece.vue'
import CostPerService from './charts/costs/costPerService.vue'
import CostPerSector from './charts/costs/costPerSector.vue'
import CostPerId from './charts/costs/costPerId.vue'
import AvoidedCosts from './charts/costs/avoidedCosts.vue'

import OrderRatings from './charts/control/orderRatings.vue'
import RankingSupplier from './charts/control/rankingSupplier.vue'
import AdhesionCalledMod from './charts/control/adhesionCalledMod.vue'
import ServiceForecast from './charts/control/serviceForecast.vue'
import CallsAnsweredChart from './charts/control/CallsAnsweredChart.vue'
import ResolutionForecast from './charts/control/resolutionForecast.vue'
import CallsResolvedChart from './charts/control/CallsResolvedChart.vue'

export default {
  name: 'ConfigureCharts',

  props: {
    isEditing: Boolean,
    chartInfosProp: Array,
    selection: Array,
    unidades: Array,
  },

  async created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.chartInfos = this.chartInfosProp
      ? this.chartInfosProp
      : this.selection.map((x) => {
          return {
            chart: x,
          }
        })
    await this.getStandardEquipments()
  },

  data() {
    return {
      apiService: new ApiService(),
      generalService: new GeneralService(),
      institution: {},
      standardEquipments: [],
      chartInfos: [],
    }
  },

  components: {
    OrderByWorkshop,
    EquipmentBySectorChart,
    RequestBySector,
    TopFiveEquipFailures,
    DefectSolutionPrev,
    SolicitedVConcluded,
    CorrectiveScheXExec,
    InternalResolvability,
    PreventiveXCorrective,
    PreventiveSchedXExec,
    CalibSchedXExec,
    EletricSecSchedXExec,
    AlienatedEquip,
    HistoricalMigration,
    StoppedEquipPendingType,
    StoppedMachine,
    StandEquipFailures,
    TotalServiceTime,
    ServiceTimeDepartment,
    ServiceTimeCrit,
    ProdTimeSector,
    ProdTime,
    ResolutionTimeCrit,
    CostPerPiece,
    CostPerService,
    CostPerSector,
    CostPerId,
    AvoidedCosts,
    OrderRatings,
    RankingSupplier,
    AdhesionCalledMod,
    ServiceForecast,
    CallsAnsweredChart,
    ResolutionForecast,
    CallsResolvedChart,
  },

  watch: {
    selection() {
      if (this.chartInfos && this.chartInfos.length > 0) {
        this.chartInfos = this.chartInfos.filter((x) =>
          this.selection.includes(x.chart)
        )

        this.chartInfos.push(
          ...this.selection
            .filter((x) => !this.chartInfos.map((x) => x.chart).includes(x))
            .map((x) => {
              return {
                chart: x,
              }
            })
        )
      } else {
        this.chartInfos = this.selection.map((x) => {
          return {
            chart: x,
          }
        })
      }
    },
  },

  methods: {
    refreshData() {
      this.$emit('refresh')
    },

    async getStandardEquipments() {
      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institution.id
        )
    },

    saveChartInfo(value) {
      let info = this.chartInfos.find((x) => x.chart == value.chart)
      let infoIndex = this.chartInfos.indexOf(info)
      if (infoIndex != -1) {
        this.chartInfos[infoIndex] = value
      } else {
        this.chartInfos.push(value)
      }
    },

    submit() {
      const find = this.chartInfos.find((x) => !x.review)

      if (find) {
        this.$toast.warning(
          `O indicador "${find.chart}" ainda não possui análise crítica`
        )
        return
      }

      this.chartInfos = this.chartInfos.filter((x) =>
        this.selection.includes(x.chart)
      )

      this.$emit('next', this.chartInfos)
    },
  },
}
</script>

<style scoped></style>
